import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { BrMaskerModule } from "brmasker-ionic-3";
import { IonicPageModule } from "ionic-angular";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { ComponentsModule } from "../../../components/components.module";
import { CompanyPageModule } from "../company.module";
import { CompanyDetailsPageModule } from "../locations/locations.module";
import { Facility } from "./facility";

@NgModule({
  declarations: [Facility],
  imports: [
    CommonComponentsModule,
    IonicPageModule.forChild(Facility),
    TranslateModule,
    ComponentsModule,
    CompanyPageModule,
    NgSelectModule,
    CompanyDetailsPageModule,
  ],
  exports: [BrMaskerModule],
})
export class FacilityModule {}



// WEBPACK FOOTER //
// ./src/pages/company/facility/facility.module.ts